'use strict';

var _lonlatCalculate = require('./util/lonlatCalculate');

var _typhoonArea = require('./util/typhoonArea');

window.positionCenter = [23.16, 113.23];
window.setPositionCenter = function (position) {
    window.positionCenter = position;
};

var posIcon = L.icon({
    iconUrl: 'assets/typhoon_current@3x.png',
    iconSize: [30, 30],
    iconAnchor: [15, 25],
    className: 'top-marker'
});
if (window.locationInfo && window.locationInfo.lat && window.locationInfo.lon) {

    positionCenter = [window.locationInfo.lat, window.locationInfo.lon];
    L.marker(positionCenter, { icon: posIcon, zIndexOffset: 10001 }).addTo(map);
    L.marker(positionCenter, {
        icon: L.divIcon({
            html: '<span class="position_text">' + window.locationInfo.city + '</span>'
        }),
        zIndexOffset: 10001
    }).addTo(map);

    var radius = [100, 300, 500];
    var colors = ['#DD8B8D', '#DD8B8D', '#5574E0'];
    radius.forEach(function (r, i) {
        L.circle(positionCenter, r * 1000, {
            fillOpacity: 0,
            weight: 2.5,
            color: colors[i],
            dashArray: '4, 5',
            dashOffset: '2',
            opacity: 1
        }).addTo(map);
        var lonlat = _lonlatCalculate.calculate.destinationVincenty(window.locationInfo, 180, r * 1000);
        L.marker([lonlat.lat, lonlat.lon], {
            icon: L.divIcon({
                html: '<span class="defense_circle_text">' + r + '\u516C\u91CC</span>'
            })
        }).addTo(map);
    });

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = _typhoonArea.lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var line = _step.value;

            L.polyline(line.path, {
                color: line.color,
                weight: 2,
                dashArray: '4, 5',
                dashOffset: '2'
            }).addTo(map);
            if (line.key === 24) {
                L.marker(line.path[0], {
                    icon: L.divIcon({
                        html: '<span class="alarm_line-text" style="position: relative; left: 12px; top: 5px; color: black;">' + line.text + '</span>'
                    })
                }).addTo(map);
            } else {
                L.marker(line.path[2], {
                    icon: L.divIcon({
                        html: '<span class="alarm_line-text" style="position: relative; left: 12px; top: 5px; color: black;">' + line.text + '</span>'
                    })
                }).addTo(map);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    map.on('zoomend', function () {
        var zoom = map.getZoom();

        if (zoom < 5) {
            $('.alarm_line-text, .defense_circle_text').hide();
        } else {
            if ($('.alarm_line-text').css('display') === 'none') {
                $('.alarm_line-text').show();
            }
            if ($('.defense_circle_text').css('display') === 'none') {
                $('.defense_circle_text').show();
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./js/position.js
// module id = 17
// module chunks = 0